import { useEffect } from 'react';
import { supabase } from '../services/supabase';
import syncService from '../services/syncService';

/**
 * Cloud sync for the signed-in login: starts once there is a session, stops on
 * unmount. If the app was opened offline there is no session yet; sync starts
 * as soon as one is available (connection back, token refreshed).
 */
export default function useCloudSync() {
  useEffect(() => {
    if (!supabase) return undefined;
    let cancelled = false;
    const begin = (session) => {
      const userId = session && session.user && session.user.id;
      if (!cancelled && userId && syncService.userId !== userId) syncService.start(userId);
    };
    supabase.auth.getSession().then(({ data }) => begin(data && data.session)).catch(() => {});
    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      // Deferred: calling Supabase from inside this callback can deadlock.
      if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') setTimeout(() => begin(session), 0);
    });
    return () => {
      cancelled = true;
      listener.subscription.unsubscribe();
      syncService.stop();
    };
  }, []);
}
